export default class Question {
  constructor (question) {
    Object.keys(question).forEach(e => { this[e] = question[e] })

    // set up the form keys that this question has
    this.formKeys = this.fields.map(({ form_key }) => form_key)

    this.hasError = false
    this.errorMsg = null
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/components/forms/question.js